import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CouponRoutingModule } from './coupon-routing.module';
import { AddUpdateCouponComponent } from './add-update-coupon/add-update-coupon.component';
import { CouponsComponent } from './coupons/coupons.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { CouponDetailsComponent } from './coupon-details/coupon-details.component';


@NgModule({
  declarations: [
    AddUpdateCouponComponent,
    CouponsComponent,
    CouponDetailsComponent
  ],
  imports: [
    CommonModule,
    CouponRoutingModule,
    SharedModule
  ]
})
export class CouponModule { }
